/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { ArrowDown } from 'lucide-react';

import { Button } from '@/lib/ChatComponents/button';
import { useAutoScroll } from '@/lib/ChatComponents/hooks/useAutoScroll';

type ChatMessageListProps = {
  smooth?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const ChatMessageList = React.forwardRef<HTMLDivElement, ChatMessageListProps>(
  ({ className, children, smooth = false, ...props }, _ref) => {
    const {
      scrollRef,
      isAtBottom,
      autoScrollEnabled,
      scrollToBottom,
      disableAutoScroll,
    } = useAutoScroll({
      smooth,
      content: children,
    });

    return (
        <div className="bb:relative bb:w-full bb:h-full">
            <div
                className={`bb:box-border bb:flex bb:flex-col bb:w-full bb:h-full bb:p-4 bb:overflow-y-auto ${className}`}
                ref={scrollRef}
                onWheel={disableAutoScroll}
                onTouchMove={disableAutoScroll}
                {...props}
            >
                <div className="bb:flex bb:flex-col bb:gap-6">{children}</div>
            </div>

            {!isAtBottom && (
                <Button
                    onClick={() => {
                        scrollToBottom();
                    }}
                    size="icon"
                    variant="outline"
                    className="bb:absolute bb:bottom-2 bb:left-1/2 bb:transform bb:-translate-x-1/2 bb:inline-flex bb:rounded-full bb:shadow-md"
                    aria-label="Scroll to bottom"
                >
                    <ArrowDown className="bb:h-4 bb:w-4" />
                </Button>
            )}
        </div>
    );
  }
);

ChatMessageList.displayName = 'ChatMessageList';

export { ChatMessageList };
